import {json} from '../core/data-source/json.mapper';

export class ChangePasswordRecord {
    @json() hash: string;

    @json() accountUrl: string;

    @json() login: string;

    @json() newPassword: string;

    @json() repeatNewPassword: string;
}
